import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsFinanceByWorkTypes(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_FINANCE_BY_WORK_TYPE,
		ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_WORK_TYPE].GET_REPORTS_FINANCE_BY_WORK_TYPE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_WORK_TYPE].GET_REPORTS_FINANCE_BY_WORK_TYPE]: _getReportsFinanceByWorkTypes,
}